import { faFileLines } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { Link, useParams } from "react-router-dom";

import { useProjectPpByPidQuery } from "api/public/project/protectionProfiles/protectionProfiles.api";
import { ProjectPp } from "api/public/project/protectionProfiles/protectionProfiles.types";

import SidebarSection from "../../SidebarSection";

const EMPTY_ARRAY = [] as ProjectPp[];

const PpClaimSection = () => {
  const { id } = useParams();

  const { data: projpps = EMPTY_ARRAY } = useProjectPpByPidQuery(
    id ?? skipToken,
  );

  return (
    <SidebarSection title="PP Claim:">
      {projpps.map(({ pp__pp_id, pp__pp_name }) => (
        <Box key={pp__pp_id} alignItems={"center"} display="flex" my={1}>
          <FontAwesomeIcon
            icon={faFileLines}
            color="#ffc207"
            size="lg"
            style={{ marginRight: ".5rem" }}
          />
          <Link key={pp__pp_id} to={`/protectionprofiles/${pp__pp_id}`}>
            <Typography variant="body1" color="primary.contrastText">
              {pp__pp_name}
            </Typography>
          </Link>
        </Box>
      ))}
    </SidebarSection>
  );
};
export default PpClaimSection;
